// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { deserialize_Translations } from "@newgenerated/shared/serializerDeserializer/Translations";
import { serialize_FrontendProject } from "@newgenerated/shared/serializerDeserializer/FrontendProject";
import { serialize_Language } from "@newgenerated/shared/serializerDeserializer/Language";

export async function getFrontendTranslations(props: { frontendProject: schema.FrontendProject; isoCode: schema.Language }): Promise<ApiResult<schema.Translations>> {
  let path = "/gaapi/txt/txids/{frontendProject}/{isoCode}";
  path = path.replace(
    "{frontendProject}",
    ((value) => {
      return ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return serialize_FrontendProject(value);
        })(),
      );
    })(props.frontendProject),
  );
  path = path.replace(
    "{isoCode}",
    ((value) => {
      return ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return serialize_Language(value);
        })(),
      );
    })(props.isoCode),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.Translations> => {
    return deserialize_Translations(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error", errorCode: null, errorMessage: "deserialize failed" };
  }
  return { kind: "success", data: deserialized.value };
}
